/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  InvoiceExtraDto,
  InvoiceExtraGetForAssignmentParams,
  InvoiceExtraSetStatusParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useInvoiceExtraGetForAssignmentHook = () => {
  const invoiceExtraGetForAssignment = useCustomInstance<InvoiceExtraDto[]>();

  return useCallback(
    (params?: InvoiceExtraGetForAssignmentParams, signal?: AbortSignal) => {
      return invoiceExtraGetForAssignment({
        url: `/api/InvoiceExtra/GetForAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [invoiceExtraGetForAssignment]
  );
};

export const getInvoiceExtraGetForAssignmentQueryKey = (
  params?: InvoiceExtraGetForAssignmentParams
) => {
  return [
    `/api/InvoiceExtra/GetForAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useInvoiceExtraGetForAssignmentQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>
  >,
  TError = unknown,
>(
  params?: InvoiceExtraGetForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getInvoiceExtraGetForAssignmentQueryKey(params);

  const invoiceExtraGetForAssignment = useInvoiceExtraGetForAssignmentHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>>
  > = ({ signal }) => invoiceExtraGetForAssignment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InvoiceExtraGetForAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>>
>;
export type InvoiceExtraGetForAssignmentQueryError = unknown;

export const useInvoiceExtraGetForAssignment = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>
  >,
  TError = unknown,
>(
  params?: InvoiceExtraGetForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useInvoiceExtraGetForAssignmentHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useInvoiceExtraGetForAssignmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useInvoiceExtraSaveHook = () => {
  const invoiceExtraSave = useCustomInstance<number>();

  return useCallback(
    (invoiceExtraDto: InvoiceExtraDto) => {
      return invoiceExtraSave({
        url: `/api/InvoiceExtra/Save`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: invoiceExtraDto,
      });
    },
    [invoiceExtraSave]
  );
};

export const useInvoiceExtraSaveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>,
    TError,
    { data: InvoiceExtraDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>,
  TError,
  { data: InvoiceExtraDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const invoiceExtraSave = useInvoiceExtraSaveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>,
    { data: InvoiceExtraDto }
  > = (props) => {
    const { data } = props ?? {};

    return invoiceExtraSave(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvoiceExtraSaveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>
>;
export type InvoiceExtraSaveMutationBody = InvoiceExtraDto;
export type InvoiceExtraSaveMutationError = unknown;

export const useInvoiceExtraSave = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>,
    TError,
    { data: InvoiceExtraDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSaveHook>>>,
  TError,
  { data: InvoiceExtraDto },
  TContext
> => {
  const mutationOptions = useInvoiceExtraSaveMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useInvoiceExtraSetStatusHook = () => {
  const invoiceExtraSetStatus = useCustomInstance<void>();

  return useCallback(
    (params?: InvoiceExtraSetStatusParams) => {
      return invoiceExtraSetStatus({
        url: `/api/InvoiceExtra/SetStatus`,
        method: 'POST',
        params,
      });
    },
    [invoiceExtraSetStatus]
  );
};

export const useInvoiceExtraSetStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>,
    TError,
    { params?: InvoiceExtraSetStatusParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>,
  TError,
  { params?: InvoiceExtraSetStatusParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const invoiceExtraSetStatus = useInvoiceExtraSetStatusHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>,
    { params?: InvoiceExtraSetStatusParams }
  > = (props) => {
    const { params } = props ?? {};

    return invoiceExtraSetStatus(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvoiceExtraSetStatusMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>
>;

export type InvoiceExtraSetStatusMutationError = unknown;

export const useInvoiceExtraSetStatus = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>,
    TError,
    { params?: InvoiceExtraSetStatusParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useInvoiceExtraSetStatusHook>>>,
  TError,
  { params?: InvoiceExtraSetStatusParams },
  TContext
> => {
  const mutationOptions = useInvoiceExtraSetStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
